import React, {FC, useEffect, useState} from 'react';
import {GxForm, GxSpinner} from '@garpix/garpix-web-components-react';
import dayjs from 'dayjs';
import {useFormik} from 'formik';
import 'react-responsive-modal/styles.css';
import {toast} from 'react-toastify';
import {useStoreon} from 'storeon/react';

import { api } from '@/api';
import ModalLayout from '../../../../components/ModalLayout';
import { TYPES_STATUS, validationSchemaOrders } from '../../consts';
import {
  createDefaultValues,
  generateArrMultiOrders,
  generateArrOrders,
  getInfoScore,
  useOrder,
} from '../../helpers';
import ModalOrderData from './ModalOrderData';
import ModalOrderHeader from './ModalOrderHeader';
import ModalOrderPayment from './ModalOrderPayment';
import PayOrder from './components/PayOrder';
import ReturnPay from './components/ReturnPay';
import MultiPayOrder from './components/MultiPayOrder';
import { getArrParticipants, orderPriceInfo } from './helpers';
import { Context, TYPE_MODAL_ORDER } from './const';

import { IModalOrder, IOrderInfo } from './interfaces';
import styles from './styles/index.module.scss';
import { TYPE_USER } from '../../../../const';


/**
 * TODO Оттипизировать formik (FormikValues) для createOrder
 */
const ModalOrder: FC<IModalOrder> = ({ flag, closeModal, data, date, selectedTypeOrder }) => {
  const {
    currentUser,
    typeOrder,
    applicationInfo,
    statusTransferOrder,
    statusCreateMultiOrders,
    arrayDateTimeOrders,
    dispatch,
    ordersInfo,
    selectedUser,
    isOnlinePaymentLoading,
  } = useStoreon(
    'currentUser',
    'typeOrder',
    'applicationInfo',
    'statusTransferOrder',
    'statusCreateMultiOrders',
    'arrayDateTimeOrders',
    'selectedUser',
    'ordersInfo',
    'isOnlinePaymentLoading',
  );


  const { createOrder, updateOrder } = useOrder();
  const [statusLoad, setStatusLoad] = useState<boolean>(false);
  const [isOrderLoading, setIsOrderLoading] = useState<boolean>(false)
  const [orderInfo, setOrderInfo] = useState<IOrderInfo>({
    visibleItem: TYPE_MODAL_ORDER.DEFAULT,
    info: null,
  });
  const [isSportsmanOrder, setIsSportsmanOrder] = useState(false);

  const getOrder = (orderId: number) => {
    return api.order.getOrder(orderId, {
      'exclude_orders_with_statuses': [TYPES_STATUS.CANCEL],
    });
  }

  const getInfoOrder = async () => {
    setIsOrderLoading(true);
    const response = await getOrder(data?.id);
    if (response) {
      setOrderInfo({
        visibleItem: TYPE_MODAL_ORDER.DEFAULT,
        info: response,
      });
      setIsOrderLoading(false)
    }
  };

  useEffect(() => {
    if (orderInfo.info && isOnlinePaymentLoading)
      dispatch('isOnlinePaymentLoading/set', false)
  }, [orderInfo])

  useEffect(() => {
    if (data) {
      getInfoOrder();
    } else {
      setIsOrderLoading(false)
    }
  }, []);

  const generateDateForUpdate = (values: Record<string, any>) => {
    let dataForUpdate: Record<string, any> = {
      participants: getArrParticipants(values.participants),
    }

    if (orderInfo.info === null) {
      return dataForUpdate;
    }

    if (values.customer.id !== orderInfo.info.customer.id) dataForUpdate.customer = values.customer;
    if (values.comment !== orderInfo.info.comment) dataForUpdate.comment = values.comment;
    if (values.is_pay_here !== orderInfo.info.is_pay_here) dataForUpdate.is_pay_here = values.is_pay_here;
    if (values.is_arrived !== orderInfo.info.is_arrived) dataForUpdate.is_arrived = values.is_arrived;
    if (values.is_automatic_stock !== orderInfo.info.is_automatic_stock) dataForUpdate.is_automatic_stock = values.is_automatic_stock;
    if (values.price_stock !== orderInfo.info.price_stock) dataForUpdate.price_stock = values.price_stock;
    if (values.stock !== orderInfo.info.stock?.id) dataForUpdate.stock = values.stock;
    if (isSportsmanOrder && typeOrder === 1 && values.session_minutes !== orderInfo.info.fly_session_minutes) {
      dataForUpdate.fly_session_minutes = values.session_minutes;
    }
    if (values.base_price !== orderInfo.info.base_price) dataForUpdate.price = values.base_price;
    if (values.promo_code !== orderInfo.info.promo_code) dataForUpdate.promo_code = values.promo_code;
    if (values.discount && values.manual_stock?.id) dataForUpdate.stock = values.manual_stock.id;
    if (orderInfo.info.tariff_rate && values.tariff_rate.id !== orderInfo.info.tariff_rate.id) dataForUpdate.tariff_rate = values.tariff_rate?.id;
    if (values.is_children !== orderInfo.info.is_children) dataForUpdate.is_children = values.is_children;

    return dataForUpdate;
  }

  const updateOrderHandler = (values: Record<string, any>) => {
    const dataForUpdate: Record<string, any> = generateDateForUpdate(values)

    updateOrder({
      switcherSpinner: setStatusLoad,
      closeModal,
      id: values.id,
      data: dataForUpdate,
      flagTransfer: statusTransferOrder
    })
  }


  // const formik = useFormik<IModalOrderFormikValues>({
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: validationSchemaOrders,
    initialValues:
      applicationInfo !== null
        ? applicationInfo
        : createDefaultValues(
            orderInfo.info,
            selectedUser
          ),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      const orderInfoUpdate = {
        comment: values.comment,
        participants: getArrParticipants(values.participants),
        is_pay_here: values.is_pay_here,
        is_arrived: values.is_arrived,
        session_minutes: values.session_minutes,
      };
      if (statusCreateMultiOrders) {
        // Мультисоздание
        try {
          const orders = generateArrMultiOrders(
            values,
            arrayDateTimeOrders,
            typeOrder,
            typeOrder
          );
          if (orders.length > 0) {
            const response = await createOrder({
              orders,
              setStatusLoad,
              flagMultiOrders: true,
              pay: true,
            });
            setStatusLoad(true);
            if (response.length > 0) {
              const order = await getOrder(response[0].id);
              setOrderInfo({
                visibleItem: TYPE_MODAL_ORDER.MULTI_PAY_ORDER,
                info: order,
              });
            }
            dispatch('flagOrArray/clear');
            dispatch('orders/get');
            setStatusLoad(false);
          }
        } catch (e) {
          console.log(e);
        }
      } else if (statusTransferOrder) { 
        // Перенос заявки
        /**
       * TODO оттипизировать data после FormikValues updateOrders
       */
        updateOrder({
          switcherSpinner: setStatusLoad,
          closeModal,
          id: values.id,
          data: {
            ...orderInfoUpdate,
            session_minutes: undefined,
            fly_session_minutes: values.session_minutes === 0 ? undefined : isSportsmanOrder && typeOrder === 1  ? values.session_minutes : undefined,
            start_at: dayjs(date, 'YYYY.MM.DD HH:mm').subtract(3, 'h').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          },
          flagTransfer: statusTransferOrder,
        });
      } else if (orderInfo.info && (currentUser.user_status === TYPE_USER.SUPERUSER || currentUser.user_status === TYPE_USER.STAFF) &&
        orderInfo.info.status === TYPES_STATUS.PAY_LOCAL) {
        //  обновление заявки со статусом Оплата на месте
        updateOrderHandler(values);
      } else if (orderInfo.info && orderInfo.info.status !== TYPES_STATUS.PAY_LOCAL) {
        // Простое обновление заявки
        /**
        * TODO оттипизировать data после FormikValues updateOrders
        */
        updateOrder({
          switcherSpinner: setStatusLoad,
          closeModal,
          id: values.id,
          data: {
            ...orderInfoUpdate,
            session_minutes: undefined
          },
          flagTransfer: statusTransferOrder,
        });
      } else {
        // Создание заявки
        const orders = [generateArrOrders({...values, isSportsmanOrder}, typeOrder, typeOrder, date)];
        createOrder({
          orders,
          setStatusLoad,
          closeModal,
          flagMultiOrders: false,
        });
      }
    },
  });

  useEffect(() => {
    if (formik.values?.is_sport) {
      setIsSportsmanOrder(
        formik.values?.is_sport
      )
    } else if (formik.values?.customer) {
      if (typeOrder === 1) {
        setIsSportsmanOrder(
          formik.values?.customer?.tube_user_type_is_sport || formik.values?.customer?.tube_user_type.is_sport
        )
      } else if (typeOrder === 2) {
        setIsSportsmanOrder(
          formik.values?.customer.wave_user_type_is_sport || formik.values?.customer?.wave_user_type.is_sport
        )
      }
    }
  }, [formik.values?.tariff?.tariff_rates, formik.values.customer]);

  const handleClickModal = async (id: number) => {
    let newOrder: Record<string, any> = [];
    if (id !== 0 && !orderInfo.info?.id) {
      // Оплата заявки, при создании
      if (statusCreateMultiOrders) {
        const orders = generateArrMultiOrders(
          formik.values,
          arrayDateTimeOrders,
          typeOrder,
          typeOrder
        );
        if (orders.length > 0) {
          newOrder = await createOrder({ orders, setStatusLoad, pay: true });
          setStatusLoad(true);
          const response = await getInfoScore(newOrder);
          setOrderInfo({
            visibleItem: TYPE_MODAL_ORDER.MULTI_PAY_ORDER,
            info: response,
          });
          dispatch('flagOrArray/clear');
          dispatch('orders/get');
        }
      } else {
        try {
          setStatusLoad(true);
          newOrder = await createOrder({
            orders: [
              generateArrOrders(formik.values, typeOrder, typeOrder, date),
            ],
            setStatusLoad,
            pay: true,
          });
          setStatusLoad(true);
          const response = await getOrder(newOrder[0].id);
          setOrderInfo({
            visibleItem: id,
            info: response,
          });
          setStatusLoad(false);
          dispatch('orders/get');
        } catch (e) {
          toast.error('Ошибка оплаты');
        }
      }
      setStatusLoad(false);
    } else if (
        id === TYPE_MODAL_ORDER.DEFAULT ||
        id === TYPE_MODAL_ORDER.MULTI_PAY_ORDER
    ) {
      setStatusLoad(true);
      if (orderInfo.info) {
        const response = await getOrder(orderInfo.info.id);
        setOrderInfo({
          visibleItem: id,
          info: response,
        });
      }
      setStatusLoad(false);
    } else if (data) {
      try {
        const dataForUpdate: Record<string, any> = generateDateForUpdate(formik.values)
        setStatusLoad(true);

        await updateOrder({
          switcherSpinner: setStatusLoad,
          id: formik.values.id,
          data: dataForUpdate,
          flagTransfer: statusTransferOrder
        })
        setStatusLoad(true);
        const response = await getOrder(formik.values.id);
        setOrderInfo({
          visibleItem: id,
          info: response,
        });
        setStatusLoad(false);
        dispatch('orders/get');
      } catch (e) {
        toast.error('Ошибка оплаты');
      }
    } else {
      if (formik.values.id === undefined ) {
        return
      }
      setOrderInfo({
        ...orderInfo,
        info: {
          ...orderInfo.info,
          ...formik.values
        },
        visibleItem: id,
      });
    }
  };

  const priceInfoOrder = orderPriceInfo(formik);

  useEffect(() => {
    if (!statusCreateMultiOrders && !data) {
      dispatch('tariffRates/get', {
        date: ordersInfo.date,
        time: dayjs(date, 'YYYY.MM.DD hh:mm').format('HH:mm'),
        is_child: formik.values.is_children,
      });
    }
  }, [formik.values.is_children]);

  // loading - после создания юзера, идет поиск по этому юзеру, чтобы подставить все данные в селект в контрагент
  const [loadingUserDataAfterCreate, setLoadingUserDataAfterCreate] = useState(false)


  const handleCloseModal = () => {
    closeModal({...formik.values});
    if (applicationInfo && !statusCreateMultiOrders && !statusTransferOrder) {
      dispatch('applicationInfo/set', null)
    }
   
    formik.setValues(
        createDefaultValues(
            orderInfo.info,
            selectedUser
        )
    );
  }

  return (
    <Context.Provider value={[orderInfo, setOrderInfo]}>
      <div>
        <ModalLayout
          flag={flag}
          onClose={handleCloseModal}
          size={
            orderInfo.visibleItem === TYPE_MODAL_ORDER.DEFAULT ? 'lg' : 'md'
          }
        >
          {
            (loadingUserDataAfterCreate || isOrderLoading) && (
              <div className={styles.spinner}>
                <GxSpinner/>
              </div>
            )
          }
          <ModalOrderHeader
            formik={formik}
            onRequestClose={closeModal}
            setVisibleItem={handleClickModal}
            visibleItem={orderInfo.visibleItem}
            data={orderInfo.info}
            date={date}
          />
          {orderInfo.visibleItem === TYPE_MODAL_ORDER.DEFAULT && (
            <GxForm className={styles[ 'form' ]} onGx-submit={formik.submitForm}>
              <div className={styles[ 'main' ]}>
                <div>
                  <div className={styles['subheader']}>
                    <span className={styles['subheader--subtitle']}>
                      Данные о контрагенте:
                    </span>
                  </div>
                  <ModalOrderData
                      loadingUserDataAfterCreate={loadingUserDataAfterCreate}
                      setLoadingUserDataAfterCreate={setLoadingUserDataAfterCreate}
                      formik={formik}
                      data={orderInfo.info}
                      date={date}
                      selectedTypeOrder={selectedTypeOrder}
                  />
                </div>
                <div className={styles[ 'payment' ]}>
                  <ModalOrderPayment
                    data={orderInfo.info}
                    statusLoad={statusLoad}
                    formik={formik}
                    onRequestClose={closeModal}
                    createOrder={createOrder}
                    setStatusLoad={setStatusLoad}
                    isOrderLoading={isOrderLoading}
                    date={date}
                    visibleItem={orderInfo.visibleItem}
                    setVisibleItem={handleClickModal}
                    setOrderInfo={setOrderInfo}
                  />
                </div>
              </div>
            </GxForm>
          )}
          {orderInfo.visibleItem === TYPE_MODAL_ORDER.PAY_ORDER && (
            <PayOrder
              onBack={() => handleClickModal(TYPE_MODAL_ORDER.DEFAULT)}
              priceInfo={priceInfoOrder}
            />
          )}
          {orderInfo.visibleItem === TYPE_MODAL_ORDER.MULTI_PAY_ORDER && orderInfo.info && (
            <MultiPayOrder
              onBack={() => handleClickModal(TYPE_MODAL_ORDER.DEFAULT)}
              data={orderInfo.info}
            />
          )}
          {orderInfo.visibleItem === TYPE_MODAL_ORDER.RETURN_PAY && orderInfo.info && (
            <ReturnPay
              onBack={() => handleClickModal(TYPE_MODAL_ORDER.DEFAULT)}
              data={orderInfo.info}
              setOrderInfo={setOrderInfo}
            />
          )}
        </ModalLayout>
      </div>
    </Context.Provider>
  );
};

export default ModalOrder;
